import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';

export async function syncStatusBar(isDarkTheme) {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return;
  }

  try {
    await SystemBars.setStyle({
      style: isDarkTheme ? SystemBarsStyle.Dark : SystemBarsStyle.Light
    });
  } catch (error) {
    console.warn('Não foi possível atualizar o estilo da barra de status.', error);
  }
}
